import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



const cardData = {
  keyword: " Innova Crysta on Rent in Pune  ",

headingDescription: "Velocity Cab provides easy and affordable Innova Crysta on rent in Pune, offering a spacious, comfortable, and premium travel experience for families, group outings, corporate travel, and leisure trips. Our well-maintained Toyota Innova Crysta vehicles come with comfortable seating for up to 6–7 passengers, generous luggage space, and smooth performance on both city roads and highways. Whether you need an hourly rental, full‑day service, airport pickup/drop, or an outstation journey, Velocity Cab offers flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt service, and 24/7 customer support, Velocity Cab is the trusted choice for Innova Crysta rental in Pune.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular weekend getaways from Pune, located around 65 km away. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive through the scenic Western Ghats while visiting attractions like Bhushi Dam, Tiger Point, and Rajmachi Viewpoint. The spacious seating and premium comfort of an Innova Crysta make it an excellent choice for families and groups planning a relaxing trip to Lonavala."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a famous hill station located about 120 km from Pune. Renting an Innova Crysta in Pune is ideal for enjoying the scenic journey to attractions like Arthur's Seat, Venna Lake, Elephant's Head Point, and Mapro Garden. The comfortable ride makes long-distance travel enjoyable for families, friends, and corporate groups."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a beautiful planned hill city approximately 60 km from Pune. Travelers hiring an Innova Crysta on rent in Pune can enjoy smooth roads, picturesque lakes, colorful buildings, and exciting adventure activities. It is a perfect destination for a one-day outing or weekend getaway."
  },
  {
    title: "Matheran",
    description: "Matheran is India's only automobile-free hill station located around 120 km from Pune. An Innova Crysta rental from Pune provides a comfortable drive to the parking point before exploring scenic viewpoints, toy train rides, and lush forests."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular beach destination around 145 km from Pune. Booking an Innova Crysta on rent in Pune offers a relaxing journey to beautiful beaches, Kolaba Fort, Varsoli Beach, and local seafood restaurants."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a peaceful hill station known for Table Land, Sydney Point, and strawberry farms. Renting an Innova Crysta in Pune makes the drive comfortable and enjoyable for families and groups exploring the scenic Western Ghats."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is one of the twelve Jyotirlingas and is located about 110 km from Pune. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this sacred temple while enjoying the scenic forest route."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is famous for the Mahalaxmi Temple, historical forts, and authentic Maharashtrian cuisine. An Innova Crysta rental from Pune provides a comfortable long-distance journey for family vacations and religious tours."
  },
  {
    title: "Nashik",
    description: "Nashik is renowned for vineyards, temples, and the Godavari River. Renting an Innova Crysta in Pune allows travelers to enjoy a premium road trip to explore Sula Vineyards, Trimbakeshwar Temple, and Panchavati."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of Maharashtra's most visited pilgrimage destinations. Booking an Innova Crysta on rent in Pune ensures a comfortable journey for families and devotees traveling to the famous Sai Baba Temple and nearby attractions."
  }
],



services: [
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service offers a premium and comfortable travel experience for families, corporate groups, and long-distance travelers. The spacious Toyota Innova provides excellent seating comfort, ample legroom, and large luggage capacity, making it ideal for highway journeys. Travel via the Mumbai–Pune Expressway ensures smooth connectivity and reduced travel time. Professional drivers ensure safe driving with timely pickup from homes, offices, and hotels across Pune. Air-conditioned vehicles with clean interiors enhance the overall travel experience. This service is perfect for airport transfers, business trips, and family outings. Easy online booking and transparent pricing make it a preferred choice for premium intercity travel."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai airport drop Innova service provides reliable and comfortable airport transfers with spacious SUV vehicles. Drivers ensure timely pickup and drop at Terminal 1 or Terminal 2 based on flight schedules. This service is ideal for travelers carrying heavy luggage or traveling in groups. Real-time traffic monitoring ensures punctual airport arrivals."
},
{
name: "Mumbai Airport to Pune Innova",
description: "Mumbai airport to Pune Innova cab service offers direct and convenient travel from airport terminals to Pune city. Drivers track flight timings to provide timely pickup without delays. Comfortable seating and smooth highway driving ensure a relaxed journey after long flights."
},
{
name: "Pune Mumbai Innova Rental",
description: "Pune Mumbai Innova rental service provides flexible vehicle rental options for intercity travel. Customers can book Innova vehicles for one-way or round trips with driver support for a comfortable and convenient journey."
},
{
name: "Pune to Mumbai Airport Innova",
description: "Pune to Mumbai airport Innova cab service ensures smooth and reliable airport transfers with premium SUV comfort. Travelers can enjoy spacious seating and safe highway travel with professional drivers."
},
{
name: "Innova Crysta on Rent in Pune Airport",
description: "Innova Crysta on rent in Pune airport offers premium SUV rental for airport pickups and drops. This service is ideal for travelers requiring comfortable and spacious travel options directly from Pune Airport."
},
{
name: "Innova per Km Rate in Pune",
description: "Innova per km rate in Pune provides transparent pricing based on distance and travel type. Customers can choose flexible packages with clear fare details including tolls and driver allowance."
},
{
name: "Pune to Andheri Innova Crysta",
description: "Pune to Andheri Innova Crysta cab service offers premium travel between Pune and Mumbai suburbs. This service is ideal for corporate travelers and families seeking comfortable and reliable transportation."
},
{
name: "Pune to Mumbai Innova Crysta",
description: "Pune to Mumbai Innova Crysta service provides luxury SUV travel with extra comfort, spacious seating, and smooth highway driving. It is perfect for long-distance journeys with family or corporate groups."
},
{
name: "Pune to Mumbai One Way Innova Crysta",
description: "Pune to Mumbai one way Innova Crysta service offers cost-effective premium travel without return charges. Ideal for airport transfers, business travel, and single-direction trips."
},
{
name: "Pune to Mumbai Innova",
description: "Pune to Mumbai Innova service ensures reliable and comfortable intercity travel with professional drivers and well-maintained vehicles."
},
{
name: "Pune Airport to Mumbai Airport Innova Cab",
description: "Pune airport to Mumbai airport Innova cab service offers seamless airport-to-airport transfers with spacious SUV comfort and timely travel."
},
{
name: "Outstation Innova Car Rental Mumbai",
description: "Outstation Innova car rental Mumbai provides reliable long-distance travel with premium SUV comfort. Travelers can book Innova vehicles for Pune and other destinations."
},
{
name: "Innova Crysta on Rent in Mumbai for Outstation Trip",
description: "Innova Crysta on rent in Mumbai for outstation trips offers comfortable and spacious travel for long journeys. It is ideal for family tours, corporate travel, and group trips."
},
{
name: "Innova per Km Rate for Outstation",
description: "Innova per km rate for outstation travel provides clear pricing based on distance and vehicle type. Customers can plan their travel budget with transparent fare details."
},
{
name: "Innova Crysta on Rent in Pune",
description: "Innova Crysta on rent in Pune offers premium SUV rental for local and outstation travel. Travelers can enjoy comfortable rides with professional drivers and well-maintained vehicles."
},
{
name: "Innova Crysta Rental Pune",
description: "Innova Crysta rental Pune provides flexible booking options for intercity and local travel with high comfort and reliability."
},
{
name: "Innova Crysta Cab in Pune",
description: "Innova Crysta cab in Pune offers dependable and comfortable transportation for airport transfers, city travel, and outstation trips."
},
{
name: "Innova Crysta Car Hire Pune",
description: "Innova Crysta car hire Pune provides premium SUV travel with spacious interiors and smooth driving experience for long-distance journeys."
},
{
name: "Book Innova Crysta in Pune",
description: "Book Innova Crysta in Pune easily through online platforms with instant confirmation and transparent pricing for hassle-free travel."
},
{
name: "Innova Crysta Taxi Service Pune",
description: "Innova Crysta taxi service Pune ensures reliable and comfortable travel with professional drivers and well-maintained vehicles."
},
{
name: "Innova Crysta on Hire Pune",
description: "Innova Crysta on hire Pune offers flexible rental options for both local and outstation travel with premium comfort."
},
{
name: "Toyota Innova Crysta Rental Pune",
description: "Toyota Innova Crysta rental Pune provides high-quality SUV travel for families and corporate clients with spacious seating and smooth performance."
},
{
name: "Innova Crysta SUV Rental Pune",
description: "Innova Crysta SUV rental Pune offers luxury travel with advanced features, comfortable interiors, and reliable performance for long journeys."
},
{
name: "Cheap Innova Crysta on Rent Pune",
description: "Cheap Innova Crysta on rent Pune provides affordable premium travel options with transparent pricing and reliable service."
}
],

tableData: [
["Pune to Mumbai Innova Cab","Pune to Mumbai Airport Drop Innova"],
["Mumbai Airport to Pune Innova","Pune Mumbai Innova Rental"],
["Pune to Mumbai Airport Innova","Innova Crysta on Rent in Pune Airport"],
["Innova per Km Rate in Pune","Pune to Andheri Innova Crysta"],
["Pune to Mumbai Innova Crysta","Pune to Mumbai One Way Innova Crysta"],
["Pune to Mumbai Innova","Pune Airport to Mumbai Airport Innova Cab"],
["Outstation Innova Car Rental Mumbai","Innova Crysta on Rent in Mumbai for Outstation Trip"],
["Innova per Km Rate for Outstation","Innova Crysta on Rent in Pune"],
["Innova Crysta Rental Pune","Innova Crysta Cab in Pune"],
["Innova Crysta Car Hire Pune","Book Innova Crysta in Pune"],
["Innova Crysta Taxi Service Pune","Innova Crysta on Hire Pune"],
["Toyota Innova Crysta Rental Pune","Innova Crysta SUV Rental Pune"],
["Cheap Innova Crysta on Rent Pune","Pune to Mumbai Innova Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta Experience",
    WhyChoosedescription: "Velocity Cabs offers luxury Innova Crysta on rent in Pune with spacious seating, premium interiors, and smooth suspension, making it perfect for long-distance travel, family trips, and corporate journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Pune city routes and outstation highways, ensuring safe driving, smooth travel, and on-time pickups and drops."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Innova Crysta rentals in Pune. Customers get complete fare details including per km charges, driver allowance, and toll charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Innova Crysta rental service in Pune operates 24/7. Whether for airport transfers, business travel, or family trips, we ensure reliable availability anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe, comfortable, and premium travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible rental options including local city use (8 hours/80 km), outstation trips, one-way travel, and customized packages based on your requirements."
  },
  {
    WhyChooseheading: "Ideal for Family & Corporate Travel",
    WhyChoosedescription: "Innova Crysta is perfect for families, corporate groups, airport transfers, and weddings with seating capacity for 6 to 7 passengers and ample luggage space."
  },
  {
    WhyChooseheading: "Trusted Car Rental Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Innova Crysta on rent in Pune due to professional drivers, premium vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Innova Crysta on rent in Pune?", answer: "Yes, Velocity Cabs provides premium Innova Crysta rental services in Pune for local and outstation travel." },
  { question: "What is the price of Innova Crysta on rent in Pune?", answer: "The rental cost typically starts from around ₹16 to ₹20 per km or ₹2500 to ₹4500 per day depending on package and duration." },
  { question: "How many passengers can travel in Innova Crysta?", answer: "Innova Crysta can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Is Innova Crysta available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using Innova Crysta vehicles." },
  { question: "Can I book Innova Crysta for outstation trips?", answer: "Yes, Innova Crysta is available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Innova Crysta rental service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Innova Crysta online?", answer: "Yes, customers can easily book Innova Crysta on rent in Pune online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals come with professional drivers for a safe and hassle-free journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "The Innova Crysta rental in Pune was a perfect choice for our family trip. The vehicle was extremely comfortable, spacious, and well-maintained for a long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "We had a great experience with the Innova Crysta on rent in Pune. The ride quality was smooth, the car was clean, and the overall service was very professional.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const puneInnovaCabJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Innova Crysta on Rent in Pune | Velocity Cabs",
  "description": "Book an Innova Crysta cab in Pune with Velocity Cabs for airport transfers, Pune to Mumbai trips, one-way or round trips, and outstation journeys. Affordable per km rates and reliable service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Innova Crysta Cab Booking Pune",
    "Pune to Mumbai Innova Crysta",
    "Pune to Mumbai Airport Innova Drop",
    "One Way Innova Crysta Cab Pune",
    "Outstation Innova Crysta Rental Pune"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Innova Crysta on Rent in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book an Innova Crysta cab in Pune with Velocity Cabs. Airport drops, Pune-Mumbai trips, one-way & round trips, and outstation rentals. Safe, reliable, and affordable service."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneInnovaCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinpune;